import { LocationService } from "shared-services";
import { config } from "../config/common";

export default new LocationService({
  url: config.locationsApiUrl,
});
